import { dynamicEnvironment, type EnvironmentConfig } from './environment-common'

export const environment: EnvironmentConfig = {
  ...dynamicEnvironment,
  production: false,
  environmentName: 'UAT',
  apiUrl: 'https://settlement-uat-api.np.ce.ameren.com',
}
